<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Copyright info</template>

    <Sheet.Body class="pt-[25px]">
      <CopyrightInfoBody :file="file" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { File } from '@/shared/graphql/router/graphql'
import CopyrightInfoBody from './CopyrightInfoBody.vue'

defineProps<{
  file: File
}>()

const { close } = useSheet()
</script>
